export interface ISkill {
   id: number;
   title: string;
   description: string;
   tag?: string;
}

export const hardSkillsData = [
   {
      id: 1,
      title: "01 - Fundamentos de HTML e CSS",
      description:
         "Inicie com os princípios do desenvolvimento web, aprendendo as linguagens fundamentais para a criação de páginas web atraentes e bem estruturadas.",
   },
   {
      id: 2,
      title: "02 - Git e Lógica com JavaScript",
      description:
         "Aprenda a controlar as versões do seu código com Git e inicie a caminhada no mundo da lógica de programação e resolução de problemas com a linguagem mais popular do mundo: JavaScript.",
   },
   {
      id: 3,
      title: "03 - DOM, CSS e JavaScript Modernos",
      description:
         "Aqui você irá se aprofundar no conhecimento e estará com preparo para começar a criar aplicações interativas e dinâmicas na Web.",
   },
   {
      id: 4,
      title: "04 - Introdução ao React",
      description:
         "Comece a dominar a biblioteca JavaScript mais popular do mercado, aprendendo a criar componentes de código modernos e reutilizáveis.",
   },
   {
      id: 5,
      title: "05 - React avançado",
      description:
         "Explore tópicos avançados, como gerenciamento de estado, roteamento e integração com APIs. Você se tornará um desenvolvedor React mais experiente.",
   },
   {
      id: 6,
      title: "06 - Fundamentos de BackEnd com Node.js",
      description:
         "Chegou a hora de explorar o mundo por trás da interface do código! Você aprenderá a criar servidores, manipular solicitações HTTP e construir APIs para suas aplicações.",
      tag: "Curso Fullstack",
   },
   {
      id: 7,
      title: "07 - Banco de Dados e Prisma ORM",
      description:
         "Ganhe um conhecimento profundo de como interagir com bancos de dados de maneira eficaz. Você terá uma compreensão sólida da persistência de dados em aplicações.",
      tag: "Curso Fullstack",
   },
   {
      id: 8,
      title: "08 - BackEnd com Python e Django",
      description:
         "Domine duas das linguagens mais pedidas pelas grandes empresas de tecnologia e ganhe a capacidade de criar aplicativos web robustos.",
      tag: "Curso Fullstack",
   },
   {
      id: 9,
      title: "09 - Soft Skills",
      description:
         "Desenvolva habilidades interpessoais que te ajudarão a se destacar no mercado de trabalho, como comunicação, trabalho em equipe e resolução de conflitos.",
   },
];
